module.exports = __webpack_public_path__ + "static/media/6901bfa4-16c7-4878-a91d-3cb6b3554af6_1.e40a8205085bdcfb9a515762e0ab9091.c3043dbc.jpeg";